import styled from '@emotion/styled';

import { useMegaMenuState, useRefinedConsoleMenuState } from '../../../../hooks';
import CategorySection from './CategorySection';

import type { MegaMenuCategory } from '@kc-console/context';

const CategoryContent = () => {
  const { allServices } = useRefinedConsoleMenuState();
  const { activeCategory } = useMegaMenuState();
  const category = allServices.find(c => c.name === activeCategory) || ({} as MegaMenuCategory);

  return (
    <CategoryContentContainer>
      <CategorySection category={category} type={'category'} />
    </CategoryContentContainer>
  );
};

const CategoryContentContainer = styled.section`
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export default CategoryContent;
